/* eslint-disable no-console */
import { initializeApp } from "firebase/app"
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"
import {
  getDatabase,
  ref,
  onValue,
  update,
  connectDatabaseEmulator,
} from "firebase/database"
import { getAuth, connectAuthEmulator, onAuthStateChanged } from "firebase/auth"
import { getStorage, connectStorageEmulator } from "firebase/storage"

import {
  UPDATE_FIREBASE_AUTH,
  UPDATE_FIREBASE_PROFILE,
  RESET_PROFILE_AUTH,
} from "./actions/types"

window.isFirebaseLoaded = true

const configProduction = {
  apiKey: "AIzaSyC26DHEz3lleN0IoM-iupz1kV7W4cHXFyE",
  appId: "1:382515012455:web:dcc038d2f4458f8ca085c2",
  authDomain: "coastlineacademy.com",
  databaseURL: "https://coastline-new-driver.firebaseio.com",
  projectId: "coastline-new-driver",
  storageBucket: "coastline-new-driver.appspot.com",
  messagingSenderId: "382515012455",
}

const configDevelopment = {
  apiKey: "AIzaSyDXn7AssGjoOqGUpRzy5J-GESNE6fFZ9SU",
  authDomain: "coastline-new-driver-dev.firebaseapp.com",
  databaseURL: "https://coastline-new-driver-dev.firebaseio.com",
  projectId: "coastline-new-driver-dev",
  storageBucket: "coastline-new-driver-dev.appspot.com",
  messagingSenderId: "475718707767",
}

const configTest = {
  apiKey: "AIzaSyCEblHQ1ARxDRMtAGJaqOZ7wSu8xGemSuI",
  authDomain: "coastline-new-driver-test.firebaseapp.com",
  databaseURL: "https://coastline-new-driver-test.firebaseio.com",
  projectId: "coastline-new-driver-test",
  storageBucket: "coastline-new-driver-test.appspot.com",
  messagingSenderId: "1094977461044",
}

let config
if (process.env.REACT_APP_ENV === "production") {
  config = configProduction
} else if (process.env.REACT_APP_ENV === "test") {
  console.log("Using test environment")
  config = configTest
} else if (process.env.REACT_APP_ENV === "development") {
  console.log("Using dev environment")
  config = configDevelopment
} else {
  console.error("Unknown environment")
  config = configDevelopment
}

const firebaseApp = initializeApp(config)

if (process.env.REACT_APP_ENV === "production") {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(
      "6LdpXusdAAAAAN6jnAt5emNJ90_zF7Fk3EMT-Rts",
    ),
    isTokenAutoRefreshEnabled: true,
  })
}

const sdk9db = getDatabase(firebaseApp)
const sdk9Auth = getAuth(firebaseApp)
const sdk9Storage = getStorage(firebaseApp)

// eslint-disable-next-line no-restricted-globals
if (location.hostname === "127.0.0.1") {
  connectDatabaseEmulator(sdk9db, "127.0.0.1", 9000)
  connectAuthEmulator(sdk9Auth, "http://127.0.0.1:9099", {
    disableWarnings: true,
  })
  connectStorageEmulator(sdk9Storage, "127.0.0.1", 9199)
}

const updateAuthState = (user, dispatch) => {
  const userAuth = {
    uid: user.uid,
    displayName: user.displayName,
    email: user.email,
    phoneNumber: user.phoneNumber,
  }

  dispatch({
    type: UPDATE_FIREBASE_AUTH,
    payload: userAuth,
  })
}

const listenUserUpdateRedux = (dispatch, getState) => {
  let profileWatchUnsub = null

  onAuthStateChanged(sdk9Auth, (user) => {
    const reduxFirebase = getState().firebase

    if (profileWatchUnsub) {
      profileWatchUnsub()
      profileWatchUnsub = null
    }

    if (!user) {
      if (!reduxFirebase.auth.isEmpty || !reduxFirebase.auth.isLoaded) {
        // initial isLoaded state is set to false, we want to show isLoaded as true
        // to prove we've loaded redux/firebase even if it is empty.
        dispatch({ type: RESET_PROFILE_AUTH })
      }
      return
    }

    updateAuthState(user, dispatch)

    profileWatchUnsub = onValue(
      ref(sdk9db, `users/${user.uid}`),
      (snapshot) => {
        const userProfile = snapshot.val()
        if (!userProfile?.email) {
          // new user, make profile
          const newUserProfile = {
            email: user.email,
            userName: user.displayName,
            signupTimestamp: new Date().valueOf(),
          }
          return update(ref(sdk9db, `users/${user.uid}`), newUserProfile)
        }
        dispatch({
          type: UPDATE_FIREBASE_PROFILE,
          payload: userProfile,
        })
        return undefined
      },
    )
  })
}

export { listenUserUpdateRedux, sdk9db, sdk9Auth, sdk9Storage }
